import { SearchService } from '@common/lib/api';
import * as search from './types';

const actions = {
  async [search.FETCH_SEARCH](commit, payload) {
    const { data } = await SearchService.getSearch(payload);
    return data;
  },
  async [search.FETCH_SEARCH_KEYWORDS](commit, payload) {
    const { data } = await SearchService.getSearchKeywords(payload);
    return data;
  },
};

export default actions;
